import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../webserviceUrls"
import { GetSavedCalculationsRequest, GetSavedCalculationsResponse, SavedCalculation } from "./models"

export function getSavedCalculations(body: GetSavedCalculationsRequest): Promise<Array<SavedCalculation>> {
    const url = `${WebserviceUrl.FastCalculator}/GetSavedCalculations`

    return ajaxAuth<GetSavedCalculationsResponse>({ url, body, method: "POST" }).then((data) => {
        return data?.savedCalculations || []
    })
}
